import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {
	
    sessionStorage.getItem("FOrder_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
   
   if(sessionStorage.getItem("OandRFOrder_Action")=="Add")
   {
	    setSaveButtonText("Save");
      setOrderNo("{Auto}");
     
      //Clear();
   
   }
   else if(sessionStorage.getItem("OandRFOrder_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("OandRFOrder_EditId"));
   }
   else if(sessionStorage.getItem("OandRFOrder_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("OandRFOrder_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }

  function ShowHideBillName()
  {
    if(CustRelationRef.current=="Own")
    setShowCustBillDetail(true);
    else
    setShowCustBillDetail(false);
    
  }

  function CustEntryClose()
  {
    setxCustName('');
    setxMobile('');
    setxAddress1('');
    setxAddress2('');
    setxAddress3('');
    setxArea('');
    setxCity('');
    setxPinCode('');
    setxPhoneNo('');
    setxEmailId('');

    CustEntryhandleClose1();

  }
  function CustOpen()
  {
    
    setCustSearchTxt('');
    setdtCust([]);
    setdtCust_Org([]);
    CusthandleShow1();

  
    GetCustList('{'+CustIdRef.current+'}');

    
  }


  function OrderOpen()
  {
    
    setOrderSearchTxt('');
    OrderhandleShow1();
    
  }

  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtStProd, setdtStProd]=useState([]);
  const [dtStSubProd, setdtStSubProd]=useState([]);
  const [dtEmp, setdtEmp,dtEmpRef]=useStateRef([]);
  const [dtCard, setdtCard]=useState([]);
  const [dtChqBank, setdtChqBank]=useState([]);
  const [dtTagInfo, setdtTagInfo]=useState([]);
 
  const [btndisabled, setDisabled] = useState('disabled');

  const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtExtras, setdtExtras]=useState([]);
  const [dtSize, setdtSize]=useState([]);
  const [dtBillType, setdtBillType, dtBillTypeRef]=useStateRef([]);
  const [BillType, setBillType, BillTypeRef]=useStateRef('PU');

  const [dtMetal, setdtMetal]=useState([]);
  const [dtCategory, setdtCategory]=useState([]);
  const [dtChitDet, setdtChitDet]=useState([]);
  
  const [dtChitBillDet, setdtChitBillDet, dtChitBillDetRef]=useStateRef([]);
  let ChitBillDetTable=[];


  const [dtCust, setdtCust,dtCustRef]=useStateRef([]);
  const [dtCust_Org, setdtCust_Org,dtCust_OrgRef]=useStateRef([]);
  
  const [dtOrder, setdtOrder,dtOrderRef]=useStateRef([]);
  const [dtOrder_Org, setdtOrder_Org,dtOrder_OrgRef]=useStateRef([]);
  
  
  const [DtCardDetTable, setDtCardDetTable, DtCardDetTableRef]=useStateRef([]);
  let CardDetTable=[];

  const [DtPurDetTable, setDtPurDetTable, DtPurDetTableRef]=useStateRef([]);
  let PurDetTable=[];

  const [DtSaleDetTable, setDtSaleDetTable, DtSaleDetTableRef]=useStateRef([]);
  let SaleDetTable=[];

  const [isPurchaseHide, setisPurchaseHide] = useState(true);
  
  const [Salesshow1, setSalesshow1] = useState(false);
  const SaleshandleClose1 = () => setSalesshow1(false);
  const SaleshandleShow1 = () => setSalesshow1(true);
  
  
  const [Purchaseshow1, setPurchaseshow1] = useState(false);
  const PurchasehandleClose1 = () => setPurchaseshow1(false);
  const PurchasehandleShow1 = () => setPurchaseshow1(true);
  
  const [Chequeshow1, setChequeshow1] = useState(false);
  const CheuqehandleClose1 = () => setChequeshow1(false);
  const ChequehandleShow1 = () => setChequeshow1(true);
  
  const [Cardshow1, setCardshow1] = useState(false);
  const CardhandleClose1 = () => setCardshow1(false);
  const CardhandleShow1 = () => setCardshow1(true);
  
  const [Custshow1, setCustshow1] = useState(false);
  const CusthandleClose1 = () => setCustshow1(false);
  const CusthandleShow1 = () => setCustshow1(true);
  
  const [Chitshow1, setChitshow1] = useState(false);
  const ChithandleClose1 = () => setChitshow1(false);
  const ChithandleShow1 = () => setChitshow1(true);
  

  const [Ordershow1, setOrdershow1] = useState(false);
  const OrderhandleClose1 = () => setOrdershow1(false);
  const OrderhandleShow1 = () => setOrdershow1(true);
 
  const [CustEntryshow1, setCustEntryshow1] = useState(false);
  const CustEntryhandleClose1 = () => setCustEntryshow1(false);
  const CustEntryhandleShow1 = () => setCustEntryshow1(true);
  
  const [OrderNo1, setOrderNo1, OrderNo1Ref] = useStateRef('');
   const [OrderNo, setOrderNo, OrderNoRef] = useStateRef(0);
   const [OrderDate, setOrderDate, OrderDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [CDueDays, setCDueDays, CDueDaysRef] = useStateRef(0);
   const [SDueDays, setSDueDays, SDueDaysRef] = useStateRef(0);
   const [SDueDate, setSDueDate, SDueDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [CDueDate, setCDueDate, CDueDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [RateNotConfirmed, setRateNotConfirmed, RateNotConfirmedRef] = useStateRef(false);

   
//order Detail
const [SaleId,setSaleId,SaleIdRef]=useStateRef('');
   
const [ProdName,setProdName,ProdNameRef]=useStateRef('');
const [SubProdName,setSubProdName,SubProdNameRef]=useStateRef('');
const [Pcs,setPcs,PcsRef]=useStateRef(0);
const [GrossWt,setGrossWt,GrossWtRef]=useStateRef(0);
const [Amt,setAmt,AmtRef]=useStateRef(0);
const [Rate,setRate,RateRef]=useStateRef(0);
const [TagInfo,setTagInfo,TagInfoRef]=useStateRef('');
const [Size,setSize,SizeRef]=useStateRef('');
const [Extras,setExtras,ExtrasRef]=useStateRef('');

//Cheque Details
   const [ChqBankName,setChqBankName,ChqBankNameRef]=useStateRef('');
   const [ChqNo,setChqNo,ChqNoRef]=useStateRef('');
   const [ChqDate,setChqDate,ChqDateRef]= useStateRef((new Date()).toISOString().substring(0,10));
   const [ChqAmount,setChqAmount,ChqAmountRef]=useStateRef('');

//Card Details   
   const [CardId,setCardId,CardIdRef]=useStateRef('');
   const [CardName,setCardName,CardNameRef]=useStateRef('');
   const [CardBankName,setCardBankName,CardBankNameRef]=useStateRef('');
   const [CardNumber,setCardNumber,CardNumberRef]=useStateRef('');
   const [CardAmount,setCardAmount,CardAmountRef]=useStateRef('');
   const [CardDate,setCardDate,CardDateRef]=useStateRef((new Date()).toISOString().substring(0,10));
   const [CardComP,setCardComP,CardComPRef]=useStateRef('');
   const [CardComAmount,setCardComAmount,CardComAmountRef]=useStateRef('');

    //chit details
    const [ChitId,setChitId,ChitIdRef]=useStateRef('');
    const [ChitCode,setChitCode,ChitCodeRef]=useStateRef('');
    const [SchemeName,setSchemeName,SchemeNameRef]=useStateRef('');
    const [ChitCustName,setChitCustName,ChitCustNameRef]=useStateRef('');
    const [ChitMobile,setChitMobile,ChitMobileRef]=useStateRef('');
    const [SettledAmount,setSettledAmount,SettledAmountRef]=useStateRef('');
    const [SettleNo,setSettleNo,SettleNoRef]=useStateRef('');
   
    
//Purchase Details
   const [PurId,setPurId,PurIdRef]=useStateRef('');
   const [PurBillNo,setPurBillNo,PurBillNoRef]=useStateRef('');
   const [PurBillDate,setPurBillDate,PurBillDateRef]=useStateRef((new Date()).toISOString().substring(0,10));
   const [PurMetal,setPurMetal,PurMetalRef]=useStateRef('');
   const [PurCategory,setPurCategory,PurCategoryRef]=useStateRef('');
   const [PurPcs,setPurPcs,PurPcsRef]=useStateRef(0);
   const [PurGrossWt,setPurGrossWt,PurGrossWtRef]=useStateRef(0);
   const [PurPurity,setPurPurity,PurPurityRef]=useStateRef(0);
   const [PurWasteP,setPurWasteP,PurWastePRef]=useStateRef(0);
   const [PurWasteGrm,setPurWasteGrm,PurWasteGrmRef]=useStateRef(0);
   const [PurWastage,setPurWastage,PurWastageRef]=useStateRef(0);
   const [PurNetWt,setPurNetWt,PurNetWtRef]=useStateRef(0);
   const [PurMC,setPurMC,PurMCRef]=useStateRef(0);
   const [PurRate,setPurRate,PurRateRef]=useStateRef(0);
   const [PurStoneAmt,setPurStoneAmt,PurStoneAmtRef]=useStateRef(0);
   const [PurAmount,setPurAmount,PurAmountRef]=useStateRef(0);
   const [PurStoneWt,setPurStoneWt,PurStoneWtRef]=useStateRef(0);
   const [PurTax,setPurTax,PurTaxRef]=useStateRef(0);
  
//Emp Details
   const [EmpId1,setEmpId1,EmpId1Ref]=useStateRef('');
   const [EmpName1,setEmpName1,EmpName1Ref]=useStateRef('');

//Customer Details
   const [CustId,setCustId,CustIdRef]=useStateRef(0);
   const [CustName,setCustName,CustNameRef]=useStateRef('');
   const [CustBillName,setCustBillName,CustBillNameRef]=useStateRef('');
   const [CustRelation,setCustRelation,CustRelationRef]=useStateRef('Own');
   
   const [Mobile,setMobile,MobileRef]=useStateRef('');
   const [Address1,setAddress1,Address1Ref]=useStateRef('');
   const [Address2,setAddress2,Address2Ref]=useStateRef('');
   const [Address3,setAddress3,Address3Ref]=useStateRef('');
   const [Area,setArea,AreaRef]=useStateRef('');
   const [City,setCity,CityRef]=useStateRef('');
   const [PinCode,setPinCode,PinCodeRef]=useStateRef('');
   const [PhoneNo,setPhoneNo,PhoneNoRef]=useStateRef('');
   const [EmailId,setEmailId,EmailIdRef]=useStateRef('');
   const [AdharNo,setAdharNo,AdharNoRef]=useStateRef('');
   const [PanNo,setPanNo,PanNoRef]=useStateRef('');
  

   const [xCustId,setxCustId,xCustIdRef]=useStateRef(0);
   const [xCustName,setxCustName,xCustNameRef]=useStateRef('');
   const [xMobile,setxMobile,xMobileRef]=useStateRef('');
   const [xAddress1,setxAddress1,xAddress1Ref]=useStateRef('');
   const [xAddress2,setxAddress2,xAddress2Ref]=useStateRef('');
   const [xAddress3,setxAddress3,xAddress3Ref]=useStateRef('');
   const [xArea,setxArea,xAreaRef]=useStateRef('');
   const [xCity,setxCity,xCityRef]=useStateRef('');
   const [xPinCode,setxPinCode,xPinCodeRef]=useStateRef('');
   const [xPhoneNo,setxPhoneNo,xPhoneNoRef]=useStateRef('');
   const [xEmailId,setxEmailId,xEmailIdRef]=useStateRef('');
   const [xAdharNo,setxAdharNo,xAdharNoRef]=useStateRef('');
   const [xPanNo,setxPanNo,xPanNoRef]=useStateRef('');
   const [xRefMobileNo,setxRefMobileNo,xRefMobileNoRef]=useStateRef('');
   const [xRefCustId,setxRefCustId,xRefCustIdRef]=useStateRef('');
   const [xRefRelation,setxRefRelation,RefxRelationRef]=useStateRef('');
   const [xRefCustName,setxRefCustName,xRefCustNameRef]=useStateRef('');
   
   const [CustSearchTxt, setCustSearchTxt, CustSearchTxtRef] = useStateRef('');
   const [dtCustRelation, setdtCustRelation, dtCustRelationRef] = useStateRef([]);
   
   const [OrderSearchTxt, setOrderSearchTxt, OrderSearchTxtRef] = useStateRef('');
   
   const [ShowCustBillDetail, setShowCustBillDetail, ShowCustBillDetailRef] = useStateRef(true);

   //Bill Details
   const [TSalesWt, setTSalesWt, TSalesWtRef] = useStateRef(0);
   
   const [PurchaseWt, setPurchaseWt, PurchaseWtRef] = useStateRef(0);
   const [PurchaseAmt, setPurchaseAmt, PurchaseAmtRef] = useStateRef(0);
   const [TotalPaid, setTotalPaid, TotalPaidRef] = useStateRef(0);
   
   const [ChitCard, setChitCard, ChitCardRef] = useStateRef(0);
   const [Cash, setCash, CashRef] = useStateRef(0);
   const [Cheque, setCheque, ChequeRef] = useStateRef(0);
   const [CreditCard, setCreditCard, CreditCardRef] = useStateRef(0);
   

   

function OrderSearchFun(text)
{
  setdtOrder(dtOrder_Org.filter(function (x) {
    return x.Search.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  


async function CustEdit(id)
{
  try {

    let postData = {
      "CustId" : id
     };
     
  
    const results = await apiService.postCall("forder/custdisplay",postData);
  
    if (results != "-1") {

      setxCustId(results.data[0][0].CustId);
      setxCustName(results.data[0][0].CustomerName)
      setxMobile(results.data[0][0].Mobile)
      setxAddress1(results.data[0][0].Address1)
      setxAddress2(results.data[0][0].Address2)
      setxAddress3(results.data[0][0].Address3)
      setxArea(results.data[0][0].Area)
      setxCity(results.data[0][0].City)
      setxPinCode(results.data[0][0].PinCode)
      setxPhoneNo(results.data[0][0].Phone)
      setxEmailId(results.data[0][0].EmailId)
      setxAdharNo(results.data[0][0].AdharNo)
      setxPanNo(results.data[0][0].PanNo)
      setxRefCustId(results.data[0][0].RefCustId)
      setxRefMobileNo(results.data[0][0].RefMobile)
      setxRefCustName(results.data[0][0].RefCustName)
      setxRefRelation(results.data[0][0].RefRelation)

      

      CustEntryhandleShow1();
     }
  } catch (error) {
       console.log(error);
     }
}

async function getChitList()
{
  try {

  let postData = {
    "CustId" : CustIdRef.current
   
   };
   

  const results = await apiService.postCall("forder/getChitList",postData);

  if (results != "-1") {

    setdtChitDet(results.data[0]);
   
    

   }
} catch (error) {
     console.log(error);
   }
}



async function getChitdetail()
{
  try {

  let postData = {
    "ChitCode" : ChitCodeRef.current
   
   };
   

  const results = await apiService.postCall("forder/getChitdetail",postData);

  if (results != "-1") {

    setChitId(0);  
    setSchemeName(results.data[0][0].SchemeName);
    setChitCustName(results.data[0][0].CustName);
    setChitMobile(results.data[0][0].MobileNo);
    setChitCode(results.data[0][0].ChitCode);
    setSettledAmount(results.data[0][0].SettledAmount);
    setSettleNo(results.data[0][0].SettleNo);
   
   }
} catch (error) {
     console.log(error);
   }
}

function CustSelect(id)
{

  var result = dtCustRef.current.find(obj => {
    return obj.CustId === id
  });
if(result!=undefined)
{

 
  setMobile(result.Mobile);
  setCustName(result.CustomerName);
  setCustId(result.CustId);
  setAddress1(result.Address1);
  setAddress2(result.Address2);
  setAddress3(result.Address3);
  setArea(result.Area);
  setCity(result.City);
  setPinCode(result.PinCode);
  setPhoneNo(result.Phone);
  setEmailId(result.EmailId);
  setPanNo(result.PanNo);
  setAdharNo(result.AdharNo);
 

}
else
{

} 

CusthandleClose1();

}

async function OrderSelect(id)
{

  let postData = {
    EditId: id
}




const results = await apiService.postCall("order/Display",postData);


if (results != "-1") {
 
let HeadData=results.data.Head;
let SalesDetail=results.data.SalesDetail;


if(SalesDetail[0].length>0)
   setDtSaleDetTable(SalesDetail[0]);


      setOrderNo1(id);
      setCDueDays(HeadData[0][0].CDueDays);
      setSDueDays(HeadData[0][0].SDueDays);
      setCDueDate(HeadData[0][0].CDueDate);
      setSDueDate(HeadData[0][0].SDueDate);
      setCustId(HeadData[0][0].CustId);
      setCustName(HeadData[0][0].CustomerName);
      setCustBillName(HeadData[0][0].PartyName);
      setMobile(HeadData[0][0].MobileNo);
      setAddress1(HeadData[0][0].Add1);
      setAddress2(HeadData[0][0].Add2);
      setAddress3(HeadData[0][0].Add3);
      setArea(HeadData[0][0].Area);
      setCity(HeadData[0][0].City);
      setPinCode(HeadData[0][0].Pincode);
      setPhoneNo(HeadData[0][0].PhoneNo);
      setEmailId(HeadData[0][0].Email);
      setAdharNo(HeadData[0][0].AdharNo);
      setPanNo(HeadData[0][0].PanNo);
      setTSalesWt(HeadData[0][0].SaleWt);
      setPurchaseWt(0);
      setChitCard(0);
      setCash(0);
      setCheque(0);
      setCreditCard(0);
      setChqBankName('');
      setChqNo('');
      setChqAmount(0);
      

     


}


OrderhandleClose1();

}



function getEmpName(id)
{
if(id==1)
{
  var result = dtEmpRef.current.find(obj => {
    return obj.OprCode === EmpId1Ref.current
  });
if(result!=undefined)
  setEmpName1(result.OprName);
else
  setEmpName1(""); 
}

}





   function PurchaseHideShow()
   {
    if(document.getElementById("chkPurchase").checked==true)
    setisPurchaseHide(false);
    else
    setisPurchaseHide(true);
    
   }

    function CardAddGrid()
   {

    if((CardNameRef.current.length>0) || (CardBankNameRef.current.length>0))
    {
      setCardId(0);
      setCardName('');
      setCardBankName('');
      setCardAmount('');
      setCardComP('');
      setCardComAmount('');
      setCardNumber('');
    }
    else
    {
    
      CardhandleClose1();
    }
     
    CardDetTable=DtCardDetTable;
    var cnt = 0;
    try {
        cnt = CardDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }
    let i=0;
    let PurAmount=0;
    for (i = 0; i < cnt; i++) {
      PurAmount=val(PurAmount)+val(CardDetTable[i].CardAmount);
    }

   
    setCreditCard(PurAmount);
    BillCalc();
   }

   async function PurchaseClear()
   {
    
    if((PurMetalRef.current.length>0) || (PurCategoryRef.current.length>0))
    {
    setPurBillNo('');
    setPurMetal('');
    setPurCategory('');
    setPurPcs('');
    setPurGrossWt('');
    setPurNetWt('');
    setPurStoneWt('');
    setPurStoneAmt('');
    setPurWasteGrm('');
    setPurWasteP('');
    setPurMC('');
    setPurRate('');
    setPurPurity('');
    setPurAmount('');
    setBillType('PU');
  }
  else
  {PurchasehandleClose1();
	}
    


	 	
   }


   async function SalesClear()
   {
    
    if((ProdNameRef.current.length>0) || (SubProdNameRef.current.length>0)|| (TagInfoRef.current.length>0))
    {
    setProdName('');
    setSubProdName('');
    setTagInfo('');
    setPcs(0);
    setAmt(0);
    setGrossWt(0);
    setExtras('');
    setSize('');

  }
  else
  {SaleshandleClose1();
	}
    


	 	
   }

   async function ChequeOpen()
   {
    ChequehandleShow1();
   }
   async function ChequeOK()
   {
    
    if((ChqBankNameRef.current.length>0) && (val(ChqAmountRef.current)>0) && (ChqNoRef.current.length>0))
     {
      setCheque(ChqAmountRef.current);
      BillCalc();

      CheuqehandleClose1();
    } 
    else
    {
      
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
    }
   }
   
   async function ChequeClose()
   {
    if(ChqBankNameRef.current.length>0)
    {
    setChqBankName('');
    setChqAmount('');
    setChqNo('');
    setCheque('');

    }
    else
    {
    CheuqehandleClose1();
    }

   }

   async function CardOpen()
   {
    CardhandleShow1();
   }



function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}

async function BillCalc()
{

  SaleDetTable=DtSaleDetTableRef.current;
  PurDetTable=DtPurDetTableRef.current;

  var cnt1 = 0;
  try {
    cnt1 = SaleDetTable.length;
  }
  catch (err) {
    cnt1 = 0;
  }
  let i1=0;
  let TSalWtWt=0;
  for (i1 = 0; i1 < cnt1; i1++) {
    TSalWtWt=val(TSalWtWt)+val(SaleDetTable[i1].GrossWt);
   
  }
  setTSalesWt(TSalWtWt.toFixed(2));
  



  var cnt1 = 0;
           try {
             cnt1 = PurDetTable.length;
           }
           catch (err) {
             cnt1 = 0;
           }
           let i=0;
           let PurWt=0;
           let PurAmt=0;
           for (i = 0; i < cnt1; i++) {
             PurWt=val(PurWt)+val(PurDetTable[i].NetWt);
             PurAmt=val(PurAmt)+val(PurDetTable[i].PurchaseAmt);
           }
           setPurchaseWt(PurWt.toFixed(2));
           setPurchaseAmt(PurAmt.toFixed(2));
  
           setTotalPaid(val(PurchaseAmtRef.current)+val(CreditCardRef.current)+val(ChitCardRef.current)+val(CashRef.current)+val(ChequeRef.current));
          
}


async function Calc()
{
  
  
  setAmt(val(val(GrossWtRef.current)*val(RateRef.current)).toFixed(2));

}


async function ControlSettings()
{

  document.getElementById("txtBillNo").disabled ='true';
  
  
  if((sessionStorage.getItem("OandRFOrder_Action")=="Edit") || (sessionStorage.getItem("OandRFOrder_Action")=="Delete"))
   {
  
   

   }

 



}

async function getxRefName()
{
  try
  {


    setxRefCustId(0);
    setxRefCustName('');

    
if(xRefMobileNoRef.current.length==10)
{
    
    let postData = {
      MobileNo :xRefMobileNoRef.current
  }

 
  const results = await apiService.postCall("forder/getcustname",postData);

 if (results != "-1") {


  if(results.data[0].length>0)
  {
  setxRefCustId(results.data[0][0].CustId);
  setxRefCustName(results.data[0][0].CustomerName);
}


}

} 
  }
  catch (error) {
    console.log(error);
  }
}


async function GetCustList(search)
{


  try
  {


    if(search.indexOf('{')==-1)
    {
    if(search.length<5)
    {
   setdtCust([]);
   setdtCust_Org([]);
   return;
    }
  }  
    
    let postData = {
      Search :search
  }

 

  const results = await apiService.postCall("forder/getcustlist",postData);

 if (results != "-1") {
   setdtCust(results.data[0]);
   setdtCust_Org(results.data[0]);

   CusthandleShow1();
 }

  
  }
  catch (error) {
    console.log(error);
  }
}



function ChitAddGrid()
{

 if((ChitCodeRef.current.length>0))
 {
  setChitId(0);
  setSchemeName('');
  setChitCustName('');
  setChitMobile('');
  setSettledAmount('');
  setChitCode('');
  setSettleNo('');


 }
 else
 {
 
   ChithandleClose1();
 }
  
 ChitBillDetTable=dtChitBillDet;
 var cnt = 0;
 try {
     cnt = ChitBillDetTable.length;
 }
 catch (err) {
     cnt = 0;
 }
 let i=0;
 let ChitAmount=0;
 for (i = 0; i < cnt; i++) {
   ChitAmount=val(ChitAmount)+val(ChitBillDetTable[i].SettledAmount);
 }


 setChitCard(ChitAmount);
 BillCalc();
}

async function ChitOpen()
{
 ChithandleShow1();
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    
  

    const results = await apiService.postCall("forder/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let SalesCard=results.data.SalesCard;
   let PurDetail=results.data.PurDetail;
   let SalesDetail=results.data.SalesDetail;
   let ChitDet=results.data.ChitDet;

   
  setisPurchaseHide(false);
 
   if(SalesCard[0].length>0)
   setDtCardDetTable(SalesCard[0]);

   if(ChitDet[0].length>0)
    setdtChitBillDet(ChitDet[0]);

   
   if(PurDetail[0].length>0) 
   { 
    setDtPurDetTable(PurDetail[0]);
    document.getElementById("chkPurchase").checked=true;
  
   }
   PurchaseHideShow();

  


  if(SalesDetail[0].length>0)
   setDtSaleDetTable(SalesDetail[0]);


   
      setOrderNo(HeadData[0][0].FOrderNo);
      setOrderDate(HeadData[0][0].FOrderDate);
      
      setOrderNo1(HeadData[0][0].OrderId);
      setCDueDays(HeadData[0][0].CDueDays);
      setSDueDays(HeadData[0][0].SDueDays);
      setCDueDate(HeadData[0][0].CDueDate);
      setSDueDate(HeadData[0][0].SDueDate);
      setEmpId1(HeadData[0][0].OprCode);
      setEmpName1(HeadData[0][0].OprName);
      setCustId(HeadData[0][0].CustId);
      setCustName(HeadData[0][0].CustomerName);
      setCustBillName(HeadData[0][0].PartyName);
      setMobile(HeadData[0][0].MobileNo);
      setAddress1(HeadData[0][0].Add1);
      setAddress2(HeadData[0][0].Add2);
      setAddress3(HeadData[0][0].Add3);
      setArea(HeadData[0][0].Area);
      setCity(HeadData[0][0].City);
      setPinCode(HeadData[0][0].Pincode);
      setPhoneNo(HeadData[0][0].PhoneNo);
      setEmailId(HeadData[0][0].Email);
      setAdharNo(HeadData[0][0].AdharNo);
      setPanNo(HeadData[0][0].PanNo);
      setTSalesWt(HeadData[0][0].SaleWt);
      setPurchaseWt(HeadData[0][0].PurWt);
      setPurchaseAmt(HeadData[0][0].PurchaesAmt);
      setTotalPaid(HeadData[0][0].TotalPaid);
      setChitCard(HeadData[0][0].ChitAmount);
      setCash(HeadData[0][0].CashAmount);
      setCheque(HeadData[0][0].ChequeAmount);
      setCreditCard(HeadData[0][0].CardAmount);
      setChqBankName(HeadData[0][0].BankName);
      setChqNo(HeadData[0][0].ChequeNo);
      setChqDate(HeadData[0][0].ChequeDate);
      setChqAmount(HeadData[0][0].ChequeAmount);
      setRateNotConfirmed(HeadData[0][0].RateNotConfirmed);
      

   getLookup();



     
     

     
       
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function CustSave(){
	  try
		{
	
		
			
			if(xCustNameRef.current=="")
      {
 
        swal({

          title: "",
          text: "Please Enter Customer Name",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }
	
      if(xMobileRef.current=="")
      {
 
        swal({

          title: "",
          text: "Please Enter Mobile",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }

      
var Action="Add";
if(val(xCustIdRef.current)>0)
  Action="Edit";

		 
		let postData = {
			"Action" : Action,
			"EditId" : xCustId,
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"CustName": xCustNameRef.current,
      "MobileNo": xMobileRef.current,
      "Address1": xAddress1Ref.current,
			"Address2": xAddress2Ref.current,
      "Address3": xAddress3Ref.current,
      "Area": xAreaRef.current,
      "City": xCityRef.current,
      "PinCode": xPinCodeRef.current,
      "PhoneNo": xPhoneNoRef.current,
      "EmailId": xEmailIdRef.current,
      "AdharNo": xAdharNoRef.current,
      "PanNo": xPanNoRef.current,
      "RefCustId": xRefCustIdRef.current,
      "RefCustMobileNo": xRefMobileNoRef.current,
      "RefCustName":xRefCustNameRef.current,
      "RefRelation": RefxRelationRef.current,
    }

    

   const results = await apiService.postCall("forder/CustSave",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(Action=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Customer Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {

     
      setdtCust(results.data[0]);
      setdtCust_Org(results.data[0]);
      
     CustEntryhandleClose1();
    });
	
  }

  else if(Action=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Customer Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {

     
      setdtCust(results.data[0]);
      setdtCust_Org(results.data[0]);

      CustEntryhandleClose1();
    });
	
  }
	 
  else if(Action=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
    CustEntryhandleClose1();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }
async function Save(){
	  try
		{
	
		
		let postData = {
			"Action" : sessionStorage.getItem("OandRFOrder_Action"),
			"EditId" : sessionStorage.getItem("OandRFOrder_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "OrderNo":OrderNoRef.current,
      "OrderDate":OrderDateRef.current,
      "OrderNo1":OrderNo1Ref.current,
      "CDueDays":CDueDaysRef.current,
      "SDueDays":SDueDaysRef.current,
      "CDueDate":CDueDateRef.current,
      "SDueDate":SDueDateRef.current,
      "RateNotConfirmed":RateNotConfirmedRef.current,
      "DtSaleDetTable":DtSaleDetTableRef.current,
      "DtPurDetTable":DtPurDetTableRef.current,
      "EmpId1":EmpId1Ref.current,
      "EmpName1":EmpName1Ref.current,
      "CustId":CustIdRef.current,
      "CustName":CustNameRef.current,
      "CustBillName":CustBillNameRef.current,
      "Mobile":MobileRef.current,
      "Address1":Address1Ref.current,
      "Address2":Address2Ref.current,
      "Address3":Address3Ref.current,
      "Area":AreaRef.current,
      "City":CityRef.current,
      "PinCode":PinCodeRef.current,
      "PhoneNo":PhoneNoRef.current,
      "EmailId":EmailIdRef.current,
      "AdharNo":AdharNoRef.current,
      "PanNo":PanNoRef.current,
      "TSalesWt":TSalesWtRef.current,
      "PurchaseWt":PurchaseWtRef.current,
      "PurchaseAmt":PurchaseAmtRef.current,
      "TotalPaid":TotalPaidRef.current,
      "ChitCard":ChitCardRef.current,
      "Cash":CashRef.current,
      "Cheque":ChequeRef.current,
      "CreditCard":CreditCardRef.current,
      "ChqBankName":ChqBankNameRef.current,
      "ChqNo":ChqNoRef.current,
      "ChqDate":ChqDateRef.current,
      "ChqAmount":ChqAmountRef.current,
      "DtCardDetTable":DtCardDetTableRef.current,
      "DtChitDet":dtChitBillDetRef.current
		}

    let ErrMsg="";


 

    if((postData.CustId==undefined)||(postData.CustId==''))
    {
      ErrMsg="Please Enter Customer";
    }
    if((EmpName1Ref.current==undefined)||(EmpName1Ref.current==''))
      {
        ErrMsg="Invalid Employee Code";
      }
      
    if((postData.EmpId1==undefined)||(postData.EmpId1==''))
    {
      ErrMsg="Please Enter Employee Code";
    }

    
    if(postData.DtSaleDetTable.length==0)
    {
      ErrMsg="Please Enter Order Details";
    }

if(ErrMsg=="")
{
    const results = await apiService.postCall("forder/Save",postData);

    if (results != "-1") {

if(results.errorCode=="8888")
{
  swal({

    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });
  return;
}  

  if(sessionStorage.getItem("OandRFOrder_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("OandRFOrder_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("OandRFOrder_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
}

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "info",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }



    
function CardCalc()
{
let CardAmount=val(CardAmountRef.current);
let CardComP=val(CardComPRef.current);

let CardComAmount=0;
CardComAmount=val(val(CardAmount)*val(CardComP)/100).toFixed(2);
setCardComAmount(CardComAmount);
}
  

    
function PurCalc()
{
let GrossWt=val(PurGrossWtRef.current);
let StoneWt=val(PurStoneWtRef.current);
let WasteP=val(PurWastePRef.current);
let Waste=0;
let NetWt=0;
let MC=val(PurMCRef.current);
let Rate=val(PurRateRef.current);
let StAmount=val(PurStoneAmtRef.current);
let Amount=0;




NetWt=val(val(GrossWt)-val(StoneWt)).toFixed(2);
Waste=val(val(NetWt)*val(WasteP)/100).toFixed(2);
NetWt=NetWt-Waste;

Amount=((val(NetWt)*val(Rate))+val(MC)+val(StAmount)).toFixed(2);

  
setPurAmount(Amount);
setPurNetWt(NetWt);
setPurWasteGrm(Waste);

}



  async function PurgridEdit (id) {

     

    PurDetTable=DtPurDetTable;

    var cnt = 0;
    try {
        cnt = PurDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }





    let i=0;

    for (i = 0; i < cnt; i++) {
        if (PurDetTable[i].ID == id) {

            setPurId(id);
            setPurBillNo(PurDetTable[i].BillNo);
            setPurBillDate(PurDetTable[i].BillDate);
            setPurMetal(PurDetTable[i].Metal);
            setPurPcs(PurDetTable[i].Pcs);
            setPurGrossWt(PurDetTable[i].GrossWt);
            setPurStoneWt(PurDetTable[i].StoneWt);
            setPurNetWt(PurDetTable[i].NetWt);
            setPurPurity(PurDetTable[i].Purity);
            setPurMC(PurDetTable[i].MC);
            setPurRate(PurDetTable[i].Rate);
            setPurStoneAmt(PurDetTable[i].StoneAmt);
            setPurWasteP(PurDetTable[i].WasteP);
            setPurWasteGrm(PurDetTable[i].WasteGrm);
            setPurAmount(PurDetTable[i].PurAmount);
            setPurCategory(PurDetTable[i].Category);
            setBillType(PurDetTable[i].BillType);
         
           
   
  await getPurCategory();
 
            break;

        }          
    }

    setDtPurDetTable(PurDetTable);
  
    PurchasehandleShow1();

}


async function SalesgridEdit (id) {

     

  SaleDetTable=DtSaleDetTable;

  var cnt = 0;
  try {
      cnt = SaleDetTable.length;
  }
  catch (err) {
      cnt = 0;
  }





  let i=0;

  for (i = 0; i < cnt; i++) {
      if (SaleDetTable[i].ID == id) {


        
        setSaleId(id);
        setProdName(SaleDetTable[i].ProdName);
        setSubProdName(SaleDetTable[i].SubProdName);
        setPcs(SaleDetTable[i].Pcs);
        setGrossWt(SaleDetTable[i].GrossWt);
        setRate(SaleDetTable[i].Rate);
        setTagInfo(SaleDetTable[i].TagInfoCode);
        setAmt(SaleDetTable[i].Amt);
        setSize(SaleDetTable[i].Size);
        setExtras(SaleDetTable[i].Extras);
        
      
          

await getSubProduct(1);

          break;

      }          
  }

  setDtSaleDetTable(SaleDetTable);

  SaleshandleShow1();

}


  async function CardgridEdit (id) {

     

    CardDetTable=DtCardDetTable;

    var cnt = 0;
    try {
        cnt = CardDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }





    let i=0;

    for (i = 0; i < cnt; i++) {
        if (CardDetTable[i].ID == id) {

            setCardId(id);
            setCardName(CardDetTable[i].CardName);
            setCardBankName(CardDetTable[i].CardBankName);
            setCardDate(CardDetTable[i].CardDate);
            setCardNumber(CardDetTable[i].CardNumber);
            setCardAmount(CardDetTable[i].CardAmount);
            setCardComP(CardDetTable[i].CardComP);
            setCardComAmount(CardDetTable[i].CardComAmount);
            
   
            break;

        }          
    }

    setDtCardDetTable(CardDetTable);
  


}



  function CardgridRemove (id) {



    CardDetTable=DtCardDetTable;
     
      var cnt = 0;
      try {
          cnt = CardDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((CardDetTable[i].ID == id))
          {
            CardDetTable.splice(i, 1);
              break;
          }
      }

      setDtCardDetTable(CardDetTable);
    
    setCardName("");
    
    
    
    //Clear();

  }

 async function SalegridRemove (id) {


  
    SaleDetTable=DtSaleDetTable;
     
      var cnt = 0;
      try {
          cnt = SaleDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((SaleDetTable[i].ID == id))
          {
            SaleDetTable.splice(i, 1);
              break;
          }
      }

      setDtSaleDetTable(SaleDetTable);
    
    setProdName('');
    
    await BillCalc();
    
    //Clear();

  }

  async function PurgridRemove (id) {


  
    PurDetTable=DtPurDetTable;
     
      var cnt = 0;
      try {
          cnt = PurDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((PurDetTable[i].ID == id))
          {
            PurDetTable.splice(i, 1);
              break;
          }
      }

      setDtPurDetTable(PurDetTable);
    
    setPurMetal('');
    
    await BillCalc();
    
    //Clear();

  }



  async function CardClear()
  {

     setCardId(0);
     setCardName('');
     setCardBankName('');
     setCardAmount('');
     setCardComP('');
     setCardComAmount('');
      setCardNumber('');

                      

  }
   

  async function CardCancel()
  {

    if((CardNameRef.current.length>0) || (CardBankNameRef.current.length>0))
    {
      setCardId(0);
      setCardName('');
      setCardBankName('');
      setCardAmount('');
      setCardComP('');
      setCardComAmount('');
       setCardNumber('');
    }
    else
    {
      CardhandleClose1();
    }
     
                      
      
  }
  async function PurgridAdd () {


    let slno=PurIdRef.current;
    let BillNo=PurBillNoRef.current;
    let BillDate=PurBillDateRef.current;
    let Metal=PurMetalRef.current;
    let Category=(PurCategoryRef.current);
    let Pcs=val(PurPcsRef.current);
    let GrossWt=val(PurGrossWtRef.current);
    let StoneWt=val(PurStoneWtRef.current);
    let NetWt=val(PurNetWtRef.current);
    let WasteP=val(PurWastePRef.current);
    let WasteGrm=val(PurWasteGrmRef.current);
    let Wastage=val(PurWastageRef.current);
    let MC=val(PurMCRef.current);
    let Rate=val(PurRateRef.current);
    let StoneAmt=val(PurStoneAmtRef.current);
    let PurAmount=val(PurAmountRef.current);
    let Purity=val(PurPurityRef.current);
    let BillType=BillTypeRef.current;
    
  
    
  
  
  if ((Metal.length>0)&&(Category.length>0)&&(NetWt>0)&&(PurAmount>0)&&(Rate>0)&&(BillType.length>0))
  
  {
      PurDetTable=DtPurDetTable;
  
  
      var cnt = 0;
      try
      {
          cnt = PurDetTable.length;
         
      }
      catch(err)
      {
          cnt=0;
      }
  
  
  
      var found = false;
      var i=0;
  
      for (i = 0; i < cnt; i++) {
  
  
  
          if ((PurDetTable[i].ID == slno)) {
  
  
            PurDetTable[i].BillNo=BillNo;
            PurDetTable[i].BillDate=BillDate;
            PurDetTable[i].Metal=Metal;
            PurDetTable[i].Category=Category;
            PurDetTable[i].Pcs=Pcs;
            PurDetTable[i].GrossWt=GrossWt;
            PurDetTable[i].StoneWt=StoneWt;
            PurDetTable[i].Purity=Purity;
            PurDetTable[i].WasteP=WasteP;
            PurDetTable[i].WasteGrm=WasteGrm;
            PurDetTable[i].Wastage=WasteGrm;
            PurDetTable[i].NetWt=NetWt;
            PurDetTable[i].MC=MC;
            PurDetTable[i].Rate=Rate;
            PurDetTable[i].StoneAmt=StoneAmt;
            PurDetTable[i].PurAmount=PurAmount;
            PurDetTable[i].BillType=BillType;
          
            //det text box clear
  
           //PurchaseClear();
  
            PurchasehandleClose1();
  
            await BillCalc();



              found = true;
              break;
          }
          else {
  
  
          if ((PurDetTable[i].Metal == Metal) && (PurDetTable[i].Category == Category) && (PurDetTable[i].Pcs == Pcs) && (parseFloat(PurDetTable[i].NetWt).toFixed(2) == parseFloat(NetWt).toFixed(2))) {
                  swal({
          title: "",
          text: "Already Found",
          icon: "info",
          button: "Ok"
  
          });
  
                  found = true;
                  break;
  
              }
          }
      }
  
  
      if (found == false) {
  
          var row = {
              "ID": parseInt(cnt) + 1
              , "BillNo":BillNo
              , "BillDate":BillDate
              , "Metal":Metal
              , "Category":Category
              , "Pcs":Pcs
              , "GrossWt":GrossWt
              , "StoneWt":StoneWt
              , "Purity":Purity
              , "WasteP":WasteP
              , "WasteGrm":WasteGrm
              , "Wastage":WasteGrm
              , "NetWt":NetWt
              , "Rate":Rate
              , "MC":MC
              , "StoneAmt":StoneAmt
              , "PurAmount":PurAmount
              , "BillType":BillType

          };
  
              PurDetTable[cnt] = row;
  
           //PurchaseClear();
           PurchasehandleClose1();
  
           await BillCalc();


           //Calc();
  
             
  
      }
    
    await setDtPurDetTable(PurDetTable);
  
  
  
  
  
    //alert(JSON.stringify(DtDetTable));
  
   PurCalc();
  
  
  }
  else
  {
  
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
  
  
  //alert("Fill All Data");
  }
  
  }
  


async function CardgridAdd () {


  let slno=CardIdRef.current;
  let CardName=CardNameRef.current;
  let CardBankName=CardBankNameRef.current;
  let CardNumber=CardNumberRef.current;
  let CardDate=CardDateRef.current;
  let CardAmount=val(CardAmountRef.current);
  let CardComP=val(CardComPRef.current);
  let CardComAmount=val(CardComAmountRef.current);
  

if ((CardBankName.length>0)&&(CardName.length>0)&&(CardAmount>0)&&(CardName.length>0))
{
  CardDetTable=DtCardDetTable;


    var cnt = 0;
    try
    {
        cnt = CardDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {



        if ((CardDetTable[i].ID == slno)) {


          CardDetTable[i].CardName=CardName;
          CardDetTable[i].CardBankName=CardBankName;
          CardDetTable[i].CardNumber=CardNumber;
          CardDetTable[i].CardAmount=CardAmount;
          CardDetTable[i].CardComP=CardComP;
          CardDetTable[i].CardComAmount=CardComAmount;
          CardDetTable[i].CardDate=CardDate;
           
           
            //det text box clear

          await CardClear();


            found = true;
            break;
        }
        else {


            if ((CardDetTable[i].CardName == CardName) && (CardDetTable[i].CardBankName == CardBankName) && (CardDetTable[i].CardNumber == CardNumber) && (parseFloat(CardDetTable[i].CardAmount).toFixed(3) == parseFloat(CardAmount).toFixed(3))) {
                swal({
        title: "",
        text: "Already Found",
        icon: "info",
        button: "Ok"

        });

                found = true;
                break;

            }
        }
    }


    if (found == false) {

        var row = {
            "ID": parseInt(cnt) + 1
            , "CardName":CardName
            , "CardBankName":CardBankName
            , "CardNumber":CardNumber
            , "CardDate":CardDate
            , "CardAmount":CardAmount
            , "CardComP":CardComP
            , "CardComAmount":CardComAmount
        };

            CardDetTable[cnt] = row;

         await CardClear();
        

         //Calc();

              

    }
  
  await setDtCardDetTable(CardDetTable);





  //alert(JSON.stringify(DtDetTable));

 CardCalc();


}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}



async function gridAdd () {


  let slno=SaleIdRef.current;
  let ProdName=ProdNameRef.current;
  let SubProdName=SubProdNameRef.current;
  let Pcs=val(PcsRef.current);
  let GrossWt=val(GrossWtRef.current);
  let Amt=val(AmtRef.current);
  let Rate=val(RateRef.current);
  let TagInfoCode=(TagInfoRef.current);
  let Size = (SizeRef.current);
  let Extras = (ExtrasRef.current);
 


if ((ProdName.length>0)&&(SubProdName.length>0)&&(GrossWt>0)&&(Amt>0)&&(Rate>0) && (TagInfoCode.length>0))
{
    SaleDetTable=DtSaleDetTable;

    var cnt = 0;
    try
    {
        cnt = SaleDetTable.length;       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {

      

        if ((SaleDetTable[i].ID == slno)) {


          SaleDetTable[i].ProdName=ProdName;
          SaleDetTable[i].SubProdName=SubProdName;
          SaleDetTable[i].Pcs=Pcs;
          SaleDetTable[i].GrossWt=GrossWt;
          SaleDetTable[i].Rate=Rate;
          SaleDetTable[i].TagInfoCode=TagInfoCode;
          SaleDetTable[i].Amt=Amt;
          SaleDetTable[i].Size=Size;
          SaleDetTable[i].Extras=Extras;
          
       
    
          //det text box clear

          SalesClear();
          SaleshandleClose1();

          await BillCalc();


            found = true;
            break;
        }
        else {


         

     
        }
    }


    if (found == false) {

   

         

        var row = {
            "ID": parseInt(cnt) + 1
            , "ProdName":ProdName
            , "SubProdName":SubProdName
            , "Pcs":Pcs
            , "GrossWt":GrossWt
            , "Rate":Rate
            , "TagInfoCode":TagInfoCode
            , "Amt":Amt
            , "Size":Size
            , "Extras":Extras
        };


      
         SaleDetTable[cnt] = row;

       
       

            SalesClear();
            SaleshandleClose1();
  
       
            await BillCalc();



         }
        


         //Calc();

           

    
  
  await setDtSaleDetTable(SaleDetTable);

 Calc();


}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

function CDateCalc()
{
  let date1=new Date(OrderDateRef.current);
  date1=date1.addDays(val(CDueDaysRef.current));
  setCDueDate(date1.toISOString().substring(0,10));
}

function SDateCalc()
{
  let date1=new Date(OrderDateRef.current);
  date1=date1.addDays(val(SDueDaysRef.current));
  setSDueDate(date1.toISOString().substring(0,10));
}


async function getSubProduct(type)
{
  try {

  let postData = {
    "ProdCode" : ProdNameRef.current
    ,"BillDate":OrderDateRef.current
   };
   

  const results = await apiService.postCall("forder/getsubProd",postData);

  if (results != "-1") {

    if(type==0)
    {
    setSubProdName('');
    setTagInfo('');
    setPcs(0);
    setGrossWt(0);
    setAmt(0);
    setRate(results.data[1]);
  }

    setdtSubProd(results.data[0][0]);
    setdtSize(results.data[3][0]);
    

   }
} catch (error) {
     console.log(error);
   }
}




async function getPurCategory()
{
  try {

  let postData = {
    "PurMetal" : PurMetalRef.current
   };
   

  const results = await apiService.postCall("forder/getpurcategory",postData);

  if (results != "-1") {
    setdtCategory(results.data[0]);
   }
} catch (error) {
     console.log(error);
   }
}


async function ChitgridAdd () {


  let slno=ChitIdRef.current;
  let SchemeName=SchemeNameRef.current;
  let ChitCustName=ChitCustNameRef.current;
  let ChitMobile=ChitMobileRef.current;
  let SettledAmount=val(SettledAmountRef.current);
  let ChitCode=ChitCodeRef.current;
  let SettleNo=SettleNoRef.current;
   
if (ChitCode.length>0)
{
  ChitBillDetTable=dtChitBillDet;


    var cnt = 0;
    try
    {
        cnt = ChitBillDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {

        if ((ChitBillDetTable[i].ID == slno)) {

          ChitBillDetTable[i].SchemeName=SchemeName;
          ChitBillDetTable[i].ChitCustName=ChitCustName;
          ChitBillDetTable[i].ChitMobile=ChitMobile;
          ChitBillDetTable[i].ChitMobile=ChitMobile;
          ChitBillDetTable[i].ChitCode=ChitCode;
          ChitBillDetTable[i].SettleNo=SettleNo;
        
           
          //det text box clear

          await ChitClear();

            found = true;
            break;
        }
        else {


            if ((ChitBillDetTable[i].ChitCode == ChitCode)) {
                swal({
        title: "",
        text: "Already Found",
        icon: "info",
        button: "Ok"

        });

                found = true;
                break;

            }
        }
    }


    if (found == false) {

        var row = {
            "ID": parseInt(cnt) + 1
            , "ChitCode":ChitCode
            , "SchemeName":SchemeName
            , "ChitCustName":ChitCustName
            , "ChitMobile":ChitMobile
            , "SettledAmount":SettledAmount
            , "SettleNo":SettleNo
        };

         ChitBillDetTable[cnt]=row;
        
         await ChitClear();
        

         //Calc();

              

    }
  
  setdtChitBillDet (ChitBillDetTable);





  //alert(JSON.stringify(DtDetTable));

 //CardCalc();


}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}


async function ChitCancel()
{

  if((ChitCodeRef.current.length>0))
  {
    setChitId(0);
    setSchemeName('');
    setChitCustName('');
    setChitMobile('');
    setSettledAmount('');    
    setChitCode('');
    setSettleNo('');
  }
  else
  {
    ChithandleClose1();
  }
   
                    
    
}

async function ChitClear()
{

setChitId(0);
setSchemeName('');
setChitCustName('');
setChitMobile('');
setSettledAmount('');    
setChitCode('');
setSettleNo('');

}
 

async function ChitOpen()
{
 ChithandleShow1();  
}

function ChitgridRemove (id) {



  ChitBillDetTable=dtChitBillDet;
   
    var cnt = 0;
    try {
        cnt = ChitBillDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }
 
  let i=0;

    for (i = 0; i < cnt; i++)
    {
        if ((ChitBillDetTable[i].ID == id))
        {
          ChitBillDetTable.splice(i, 1);
            break;
        }
    }

    setdtChitBillDet(ChitBillDetTable);
  
  setChitCode("");
  
  
  
  //Clear();

}

  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : 0
    };
		
    const results = await apiService.postCall("forder/Lookup",postData);

	 if (results != "-1") {

    setdtEmp(results.data[0][0]);
    setdtCard(results.data[1][0]);
    setdtChqBank(results.data[2][0]);
    setdtMetal(results.data[3][0]);
    setdtCategory(results.data[4][0]);
    setdtProd(results.data[5][0]);
    setdtSubProd(results.data[6][0]);
    setdtTagInfo(results.data[7][0]);
    setdtExtras(results.data[8][0]);
    setdtSize(results.data[9][0]);
    setdtOrder(results.data[10][0]);
    setdtOrder_Org(results.data[10][0]);
    setdtBillType(results.data[11][0]);
   

    let Relation=[
      {"Relation":"Own"},
      {"Relation":"Father"},
      {"Relation":"Mother"},
      {"Relation":"Son"},
      {"Relation":"Daughter"},
      {"Relation":"Husband"},
      {"Relation":"Wife"},
      {"Relation":"Brother"},
      {"Relation":"Sister"},
      {"Relation":"Grandfather"},
      {"Relation":"Grandmother"},
      {"Relation":"Grandson"},
      {"Relation":"Granddaughter"},
      {"Relation":"Uncle"},
      {"Relation":"Aunt"},
      {"Relation":"Son-in-law"},
      {"Relation":"Daughter-in-law"},
      {"Relation":"Cousins"},
      {"Relation":"Friend"},
      {"Relation":"Others"}
   
    ]

  
    setdtCustRelation(Relation);
    
    await getChitList();

      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/oandr/forder/list');
  };


  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

              
                <div className='row'>
                  <div className='col-lg-8'>
                       
                        <div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>Entry No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtBillNo" placeholder="" value={OrderNo}  />
                          </div>
                         
                          <div className='col-md-4'>
                            <Form.Label>Entry Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtBillDate" placeholder="" value={OrderDate} onChange={(e)=>setOrderDate(e.target.value)} />
                          </div>
						  
                          <div className='col-md-4'>
                          <Form.Label><span className='spanLink' onClick={OrderOpen}>Order No</span></Form.Label>
                             <Form.Control type="text" Readonly="Readonly"  placeholder="" value={OrderNo1} onChange={(e)=>setOrderNo1(e.target.value)} />
                          </div>

                          <div className='col-md-12'>
  <Form className='form-horizontal'>
  <Form.Label>Cust.Due Days</Form.Label>
  <div className='row'>
    <div className='col-md-4'> <Form.Control type="number"  Readonly="Readonly" className='txtReadOnly'  value={CDueDays} onKeyUp={CDateCalc}  onChange={(e)=>setCDueDays(e.target.value)}  placeholder=""   />
 </div>
 <div className ='col-md-4'> <Form.Control className='col-md-10 txtReadOnly' type="date"   value={CDueDate}   placeholder=""  Readonly="Readonly"    />
 </div>
</div>
</Form>
</div>
                          

<div className='col-md-12'>
  <Form className='form-horizontal'>
  <Form.Label>Smith Due Days</Form.Label>
  <div className='row'>
    <div className='col-md-4'> <Form.Control  Readonly="Readonly"  type="number" className='txtReadOnly' value={SDueDays} onKeyUp={SDateCalc}  onChange={(e)=>setSDueDays(e.target.value)}  placeholder=""   />
 </div>
 <div className ='col-md-4'> <Form.Control className='col-md-10 txtReadOnly' type="date"   value={SDueDate}   placeholder=""  Readonly="Readonly"    />
 </div>
</div>
</Form>
</div>

</div>
</div>

<div className='col-lg-6'>
<div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
<div className='row py-2'>
<div className='col-md-8'>
  </div>                  



                        </div>
                        </div>
                        </div>

</div>
                  </div>
                 
                  <div className='row'>
                  <div className='col-lg-12'>
                    
           
    <div className="table-responsive mt-4" >
			 
      
       	   
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th hidden='true'>Edit</th>
             <th>Product</th>
             <th>Sub Product</th> 
             <th>Tag Info</th>                       
             <th>Pcs</th>
             <th>Weight</th>
             <th>Rate</th>  
             <th>Extras</th>  
             <th>Size</th>  
           
             
   <th hidden='true'>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtSaleDetTable.map((item) => (
           <tr>
              <td hidden='true'>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>SalesgridEdit(item.ID)}  >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.ProdName}</td>
             <td>{item.SubProdName}</td>
             <td>{item.TagInfoCode}</td>
             <td>{item.Pcs}</td>                 
             <td>{item.GrossWt}</td>
             <td>{item.Rate}</td>  
             <td>{item.Extras} </td>  
             <td>{item.Size}</td>  
            
             
<td hidden='true'>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>SalegridRemove(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
   )
   )
    }     
         </tbody>
       </Table>
<div className="EntryPan" hidden='true'>

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#"  onClick=
                              {
                                (e) => {
                              setSaleId('');
                              SaleshandleShow1();
                                }
                                } >
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>




</div>



                         
                         
     </div>
     
     

     
      
    <div className="table-responsive mt-4" >
			 
    <div className='span101'>
       <input type="checkbox" id="chkPurchase" onClick={PurchaseHideShow}></input>
       <span className='span101'> OJ Details</span>
       
		   </div>
       	   
       <Table striped id="basic-table" hidden={isPurchaseHide} className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Edit</th>
             <th>Metal</th>
             <th>Gategory</th>
             <th>Pcs</th>
             <th>Gross Wt</th>
             <th>Waste</th>  
             <th>Stone Wt</th>
             <th>Net Wt</th>  
             <th>Rate</th>  
             <th>Amount</th>  
             
   <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtPurDetTable.map((item) => (
           <tr>
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>PurgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>  

             <td>{item.Metal}</td>
             <td>{item.Category}</td>
             <td>{item.Pcs}</td>
             <td>{item.GrossWt}</td>                 
             <td>{item.WasteGrm}</td>
             <td>{item.StoneWt}</td>
             <td>{item.NetWt}</td>
             <td>{item.Rate}</td>  
             <td>{item.PurAmount}</td>  
            
            
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>PurgridRemove(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
             )
             )
              }     
         </tbody>
       </Table>
<div className="EntryPan" hidden={isPurchaseHide}>
<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Delete" to="#" onClick={PurchasehandleShow1}>
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>



</div>


    


     </div>
     
     
   
      <div className='row'>
      <div className='col-lg-3'>
       <div className='col-md-12'>
      <Form.Label>Mobile No</Form.Label>
      <Form.Control type="text" Readonly="Readonly" value={Mobile} placeholder="" className='txtReadOnly'  />
    </div>
    <div className='col-md-12'>
      <Form.Label>Customer Name</Form.Label>
      <Form.Control type="text" Readonly="Readonly"  placeholder=""  value={CustName}  className='txtReadOnly' />
      <Form.Control type="hidden" Readonly="Readonly" value={CustId}  placeholder=""   />
    </div>
</div>

<div className='col-lg-12' hidden={ShowCustBillDetail} id="divBillingName">
<div className='row'>
<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Billing Name</Form.Label>
      <Form.Control type="text" value={CustBillName} onChange={(e)=>setCustBillName(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Address</Form.Label>
      <Form.Control type="text" value={Address1} onChange={(e)=>setAddress1(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label></Form.Label>
      <Form.Control type="text" value={Address2} onChange={(e)=>setAddress2(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label></Form.Label>
      <Form.Control type="text" value={Address3} onChange={(e)=>setAddress3(e.target.value)} placeholder=""   />
    </div>
</div>
  
<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Area</Form.Label>
      <Form.Control type="text" value={Area} onChange={(e)=>setArea(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>City</Form.Label>
      <Form.Control type="text" value={City} onChange={(e)=>setCity(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label>Pincode</Form.Label>
      <Form.Control type="text" value={PinCode} onChange={(e)=>setPinCode(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label>Email Id</Form.Label>
      <Form.Control type="text" value={EmailId} onChange={(e)=>setEmailId(e.target.value)} placeholder=""   />
    </div>
</div>



<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Adhar No</Form.Label>
      <Form.Control type="text" value={AdharNo} onChange={(e)=>setAdharNo(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Pan No</Form.Label>
      <Form.Control type="text" value={PanNo} onChange={(e)=>setPanNo(e.target.value)} placeholder=""   />
    </div>
    
   
</div>


</div>
</div>


<div className='col-lg-2'>
    <div className='col-md-12'>
      <Form.Label>Order Wt</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={TSalesWt} placeholder="" className='txtReadOnly'   />
    </div>

    <div className='col-md-12'>
      <Form.Label>OJ Wt</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={PurchaseWt} placeholder="" className='txtReadOnly'   />
    </div>



        </div>

       

       



    <div className='col-lg-2'>

    <div className='col-md-12'>
  <Form.Label><span className='spanLink'>Advance Amount</span></Form.Label>
  <Form.Control type="number" Readonly="Readonly" onKeyUp={BillCalc} value={PurchaseAmt} onChange={(e)=>setPurchaseAmt(e.target.value)}  placeholder="" className='txtReadOnly'   />
</div>

<div className='col-md-12'>
  <Form.Label><span className='spanLink'  onClick={ChitOpen}>Chit Card</span></Form.Label>
  <Form.Control type="number" Readonly="Readonly" onKeyUp={BillCalc} value={ChitCard} onChange={(e)=>setChitCard(e.target.value)}  placeholder="" className='txtReadOnly'   />
</div>

<div className='col-md-12'>
  <Form.Label><span className='spanLink' onClick={ChequeOpen}>Cheque</span></Form.Label>
  <Form.Control type="number" Readonly="Readonly" value={Cheque} onChange={(e)=>setCheque(e.target.value)}  placeholder=""  className='txtReadOnly'  />
</div>



      </div>

      <div className='col-lg-2'>

      <div className='col-md-12'>
  <Form.Label><span className='spanLink' onClick={CardOpen}>Credit Card</span></Form.Label>
  <Form.Control type="number" Readonly="Readonly" value={CreditCard}  onChange={(e)=>setCreditCard(e.target.value)}  placeholder=""  className='txtReadOnly'  />
</div>

<div className='col-md-12'>
  <Form.Label>Cash</Form.Label>
  <Form.Control type="number" value={Cash} onKeyUp={BillCalc} onChange={(e)=>setCash(e.target.value)} placeholder=""   />
</div>

<div className='col-md-12'>
  <Form.Label><span className='spanLink'>Total Advance</span></Form.Label>
  <Form.Control type="number" Readonly="Readonly"  value={TotalPaid} onChange={(e)=>setTotalPaid(e.target.value)}  placeholder="" className='txtReadOnly'   />
</div>


        </div>
    
     

  
     </div>

    
      <div className='row'>

      <div className='col-lg-3'>
      <div className='col-md-12'>
  <Form.Label>Emp Id</Form.Label>
  <Form.Control type="text" value={EmpId1} onChange=
                            {
                              (e) => {
                            setEmpId1(e.target.value);
                            getEmpName(1);
                              }
                              } placeholder=""   />
</div>



</div>

<div className='col-lg-4'>
      <div className='col-md-12'>
  <Form.Label>Emp Name</Form.Label>
  <Form.Control type="text"  placeholder="" value={EmpName1}  className="txtReadOnly" Readonly="ReadOnly"  />
</div>
 
</div>



        </div>
    

                     
                     
                    
                  </div>
              </div>
              </div>
             	
              <Modal show={Salesshow1} className=".modal-xl" id="EntryModal4" >
                  <Modal.Header>
                    <Modal.Title>Sales Product Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                            <div className='col-md-4'>

        <Form.Label>Product</Form.Label>
         <Select className="form-select-search" 
       options={dtProd}
       value={dtProd.filter(function(option) {
        return option.value === ProdName;
      })}
      onChange=
      {
        (e) => {
      setProdName(e.value);
      getSubProduct(0);
        }
        }
       disabled={false}>
       </Select>
       

     
      </div>

  

<div className='col-md-4'>
        <Form.Label>Sub Product</Form.Label>

        <Select className="form-select-search" id="txtStProductName" 
       options={dtSubProd}
       value={dtSubProd.filter(function(option) {
        return option.value === SubProdName;
      })}
      onChange=
      {
        (e) => {
      setSubProdName(e.value);
        }
        }
       disabled={false}>
       </Select>
       

      </div>
                    
      <div className='col-md-2'>
                              <Form.Label>Tag Info</Form.Label>
                              <select className="form-select"  value={TagInfo}
                              onChange=
                              {
                                (e) => {
                              setTagInfo(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtTagInfo.map(
                              (item)=>(
                              <option value={item.value}>{item.label}</option>
                              )
                              )
                              }
                             </select>

                            </div>
                    
                
                        
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" value={Pcs}  onChange={(e) => {setPcs(e.target.value);}} onKeyUp={Calc}    placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Weight</Form.Label>
                            <Form.Control type="text"value={GrossWt}  onChange={(e) => {setGrossWt(e.target.value);}} onKeyUp={Calc}  placeholder=""  />
                            </div>
                            
              
                            <div className='col-md-2'>
                              <Form.Label>Rate</Form.Label>
                            <Form.Control type="text" value={Rate}  onChange={(e) => {setRate(e.target.value);}} onKeyUp={Calc} placeholder=""   />
                            </div>


                            <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                            <Form.Control type="text" value={Amt}  onChange={(e) => {setAmt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>


                            <div className='col-md-2'>
                              <Form.Label>Extras</Form.Label>
                              <select className="form-select"  value={Extras}
                              onChange=
                              {
                                (e) => {
                              setExtras(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtExtras.map(
                              (item)=>(
                              <option value={item.value}>{item.label}</option>
                              )
                              )
                              }
                             </select>

                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Size</Form.Label>
                              <select className="form-select"  value={Size}
                              onChange=
                              {
                                (e) => {
                              setSize(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtSize.map(
                              (item)=>(
                              <option value={item.value}>{item.label}</option>
                              )
                              )
                              }
                             </select>

                            </div>

</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={gridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={SalesClear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
          
             
				
                <Modal show={Purchaseshow1}  className=".modal-xl " id="EntryModal2"  >
                  <Modal.Header>
                    <Modal.Title>Purchase Product Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                    
                         

                            <div className='col-md-3'>
                              <Form.Label>Metal</Form.Label>
                            <Select className="form-select-search" id="txtStProductName" 
                             options={dtMetal}
                             value={dtMetal.filter(function(option) {
                              return option.value === PurMetal;
                            })}
                            onChange=
                            {
                              (e) => {
                            setPurMetal(e.value);
                            getPurCategory();
                              }
                              }
                             disabled={false}>
              				       </Select>     
                            </div>
                            <div className='col-md-3'>
                              <Form.Label>Category</Form.Label>
                          <Select className="form-select-search" id="txtStProductName" 
                             options={dtCategory}
                             value={dtCategory.filter(function(option) {
                              return option.value === PurCategory;
                            })}
                            onChange=
                            {
                              (e) => {
                            setPurCategory(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>  
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Purchase Type</Form.Label>
                            <Select className="form-select-search" id="txtBillType1" 
                             options={dtBillType}
                             value={dtBillType.filter(function(option) {
                              return option.value === BillType; 
                            })}
                            onChange=
                            {
                              (e) => {
                            setBillType(e.value);
                           
                              }
                              }
                             disabled={false}>
              				       </Select>     
                            </div>
                
                
                        
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="number" id="txtPcs" value={PurPcs}
                            onChange=
                            {
                              (e) => {
                            setPurPcs(e.target.value);
                            PurCalc();
                              }
                              }
                              placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="number" id="txtGrossWt" value={PurGrossWt}
                             onChange=
                            {
                              (e) => {
                            setPurGrossWt(e.target.value);
                            PurCalc();
                              }
                              }  placeholder=""  />
                            </div>
                            
                           

                            <div className='col-md-2'>
                              <Form.Label>Stone Wt</Form.Label>
                            <Form.Control type="number" id="txtPurStoneWt" value={PurStoneWt} 
                             onChange=
                            {
                              (e) => {
                            setPurStoneWt(e.target.value);
                            PurCalc();
                              }
                              }placeholder="" />
                            </div>

                            
                           
                           
                            <div className='col-md-2'>
                              <Form.Label>Purity</Form.Label>
                            <Form.Control type="number" id="txtPurPurity" value={PurPurity} 
                             onChange=
                            {
                              (e) => {
                            setPurPurity(e.target.value);
                            PurCalc();
                              }
                              } placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste %</Form.Label>
                            <Form.Control type="number" id="txtPurWasteP" value={PurWasteP} 
                             onChange=
                            {
                              (e) => {
                            setPurWasteP(e.target.value);
                            PurCalc();
                              }
                              } placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste Grm</Form.Label>
                            <Form.Control type="number"  className='txtReadOnly' Readonly="Readonly" id="txtPurWasteGrm" value={PurWasteGrm}  onChange=
                            {
                              (e) => {
                            setPurWasteGrm(e.target.value);
                              }
                              }  placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="number" id="txtPurNetWt"  className='txtReadOnly' Readonly="Readonly" value={PurNetWt}  onChange=
                            {
                              (e) => {
                            setPurNetWt(e.target.value);
                              }
                              } placeholder=""   />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Rate</Form.Label>
                            <Form.Control type="number" id="txtPurRate" value={PurRate}  onChange=
                            {
                              (e) => {
                            setPurRate(e.target.value);
                            PurCalc();
                              }
                              }  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Stone Amount</Form.Label>
                            <Form.Control type="number" id="txtPurStAmt" value={PurStoneAmt}  onChange=
                            {
                              (e) => {
                            setPurStoneAmt(e.target.value);
                            PurCalc();
                              }
                              }  placeholder="" />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                            <Form.Control type="number" id="txtPurAmt" value={PurAmount}  onChange=
                            {
                              (e) => {
                            setPurAmount(e.target.value);
                            
                              }
                              }  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                           
                            
                          


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={PurgridAdd}>OK</Button>
					<Button type="button" className="detbutton" variant="btn btn-primary" onClick={PurchaseClear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				  

                <Modal show={Chequeshow1}  className=".modal-xl"  >
                  <Modal.Header >
                    <Modal.Title>Cheque/DD Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                        <div className='col-md-12'>
                              <Form.Label>Bank Name</Form.Label>
                              <Select className="form-select-search" 
                             options={dtChqBank}
                             value={dtChqBank.filter(function(option) {
                              return option.value === ChqBankName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setChqBankName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                     
                            </div>

                        <div className='col-md-12'>
                              <Form.Label>Cheque/DD No</Form.Label>
                              <Form.Control type="text"   value={ChqNo} onChange=
                            {
                              (e) => {
                            setChqNo(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                            <div className='col-md-12'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date"  value={ChqDate} onChange=
                            {
                              (e) => {
                            setChqDate(e.target.value);
                              }
                              } placeholder=""  />
                          </div>

                            <div className='col-md-12'>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control type="number" value={ChqAmount} onChange=
                            {
                              (e) => {
                            setChqAmount(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                                 


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={ChequeOK}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={ChequeClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
                <Modal show={Cardshow1} className=" .modal-xl" id="EntryModal1" >
                  <Modal.Header >
                    <Modal.Title>Card Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-2'>
                              <Form.Label>Card Type</Form.Label>
                     
                              <Select className="form-select-search"  
                             options={dtCard}
                             value={dtCard.filter(function(option) {
                              return option.value === CardName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setCardName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                                           </div>
                    
                      <div className='col-md-5'>
                              <Form.Label>Bank</Form.Label>
                              <Select className="form-select-search"  
                             options={dtChqBank}
                             value={dtChqBank.filter(function(option) {
                              return option.value === CardBankName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setCardBankName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                        </div>
                      <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control type="number"  value={CardAmount}  onChange=
                            {
                              (e) => {
                            setCardAmount(e.target.value);
                            CardCalc();
                              }
                              }  placeholder="" />
                      </div>

                      <div className='col-md-3'>
                              <Form.Label>Com.%</Form.Label>
                              <div className='row'>
    <div className='col-md-4'> <Form.Control  type="number"  value={CardComP}  onChange=
                            {
                              (e) => {
                            setCardComP(e.target.value);
                            CardCalc();
                              }
                              } placeholder=""    /> 
 </div>
 <div className ='col-md-8'> <Form.Control className='col-md-10 txtReadOnly' type="number" Readonly="Readonly" value={CardComAmount} onChange=
                            {
                              (e) => {
                            setCardComAmount(e.target.value);
                            CardCalc();
                              }
                              }  placeholder=""   />
 </div>
</div>
                      </div>

                      <div className='col-md-8'>
                              <Form.Label>Card No</Form.Label>
                              <Form.Control type="text"  value={CardNumber}  onChange=
                            {
                              (e) => {
                            setCardNumber(e.target.value);
                              }
                              }  placeholder="" />
                      </div>
                  
                      <div className='col-md-4'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date"  placeholder="" value={CardDate} onChange={(e)=>setCardDate(e.target.value)} />
                          </div>

                            

                            <div style={{ "text-align": 'center' }}>
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={CardgridAdd}>Add to Table</Button>
					              </div>


                       <div className="table-responsive mt-4" >
			 
				
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Edit</th>
           <th>Card Name</th>
             <th>Bank Name</th>
             <th>Card No</th>
             <th>Amount</th>   
             <th>Com.%</th>   
             <th>Com.Amt</th>   

            <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtCardDetTable.map((item) => (
           <tr >
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CardgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.CardName}</td>
             <td>{item.CardBankName}</td>
             <td>{item.CardNumber}</td>
             <td>{item.CardAmount}</td>
             <td>{item.CardComP}</td>
             <td>{item.CardComAmount}</td>
           
           
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>CardgridRemove(item.ID)}>
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>
<div className="EntryPan">

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#" onClick={CardClear}>
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>



</div>
     </div>

     <div style={{ "direction": 'rtl' }}>
  
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={CardAddGrid}>OK</Button>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick=
                    {e=>{
                      CardCancel();
                      }}>Cancel</Button>
  </div>

</div>
</div>

                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>


                <Modal show={Chitshow1} className=" .modal-xl" id="EntryModal1" >
                  <Modal.Header >
                    <Modal.Title>Chit Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-2'>
                              <Form.Label>Chit Code</Form.Label>
                     
                              <Select className="form-select-search"  
                             options={dtChitDet}
                             value={dtChitDet.filter(function(option) {
                              return option.value === ChitCode;
                            })}
                            onChange=
                            {
                              (e) => {
                            setChitCode(e.value);
                            getChitdetail();
                              }
                              }
                             disabled={false}>
              				       </Select>
                                           </div>
                    
                  
                      <div className='col-md-4'>
                              <Form.Label>Scheme Name</Form.Label>
                              <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  value={SchemeName}   placeholder="" />
                      </div>
                      <div className='col-md-3'>
                              <Form.Label>Name</Form.Label>
                              <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  value={ChitCustName}   placeholder="" />
                      </div>

                      <div className='col-md-3'>
                              <Form.Label>Mobile</Form.Label>
                              <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  value={ChitMobile}   placeholder="" />
                      </div>
                      
                         <div className='col-md-2'>
                              <Form.Label>Settle No</Form.Label>
                              <Form.Control type="number" Readonly="ReadOnly" className='txtReadOnly'  value={SettleNo}   placeholder="" />
                      </div>

                                <div className='col-md-2'>
                              <Form.Label>Settled Amount</Form.Label>
                              <Form.Control type="number" Readonly="ReadOnly" className='txtReadOnly'  value={SettledAmount}   placeholder="" />
                      </div>

                            <div style={{ "text-align": 'center' }}>
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={ChitgridAdd}>Add to Table</Button>
					              </div>


                       <div className="table-responsive mt-4" >
			 
				
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Chit Code</th>
             <th>Scheme Name</th>
             <th>Name</th>
             <th>Mobile</th>   
             <th>Amount</th>   

            <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {dtChitBillDet.map((item) => (
           <tr >
             

             <td>{item.ChitCode}</td>
             <td>{item.SchemeName}</td>
             <td>{item.ChitCustName}</td>
             <td>{item.ChitMobile}</td>
             <td>{item.SettledAmount}</td>
          
           
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>ChitgridRemove(item.ID)}>
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>
<div className="EntryPan">

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#" onClick={ChitClear}>
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>



</div>
     </div>

     <div style={{ "direction": 'rtl' }}>
  
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={ChitAddGrid}>OK</Button>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick=
                    {e=>{
                      ChitCancel();
                      }}>Cancel</Button>
  </div>

</div>
</div>

                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>


                <Modal show={Custshow1} className=" .modal-xl" onHide={CusthandleClose1} id="EntryModal1" >
                  <Modal.Header closeButton>
                    <Modal.Title>Customer Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <Form.Group className="mb-12" >

                    <div className="table-responsive mt-4" id="EntryModalCust" >
			 
       <div className="row">
                    <div className='col-md-11'>
                              <Form.Control type="text"  value={CustSearchTxt}     onChange=
                            {
                              (e) => {
                            setCustSearchTxt(e.target.value);
                            GetCustList(e.target.value);
                              }
                              }  placeholder="Search (Minimum 5 Letters)" />
</div>
<div className='col-md-1'>
                <Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#" onClick= {
                              (e) => {
                            setxMobile(CustSearchTxtRef.current);
                            setxCustId(0);
                            setxCustName('');
                            setxAddress1('');
                            setxAddress2('');
                            setxAddress3('');
                            setxCity('');
                            setxPinCode('');
                            setxArea('');
                            setxPhoneNo('');
                            setxEmailId('');

                            CustEntryhandleShow1();
                              }
                              } >
                   <span className="btn-inner">
                   <svg class="icon-32" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>

                      </div>
                      </div>
                      
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Select</th>   
           <th>Customer Name</th>
             <th>Mobile No</th>
             <th>Area</th>
             <th>City</th>   
             <th>Edit</th>
         
           </tr>
         </thead>
         <tbody>
         {dtCust.map((item) => (
           <tr >
             
             <td>

                                  

    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CustSelect(item.CustId)} >
                   <span className="btn-inner">

                   <svg class="icon-32" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
              <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                
              </svg>  

                     
                   </span>
                 </Link>
   </td>
             <td>{item.CustomerName}</td>
             <td>{item.Mobile}</td>
             <td>{item.Area}</td>
             <td>{item.City}</td>
             
           

             <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CustEdit(item.CustId)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             

           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>

     </div>


				
                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>

                <Modal show={Ordershow1} className=" .modal-xl" onHide={OrderhandleClose1} id="EntryModal1" >
                  <Modal.Header closeButton>
                    <Modal.Title>Order Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <Form.Group className="mb-12" >

                    <div className="table-responsive mt-4" id="EntryModalCust" >
			 
       <div className="row">
                    <div className='col-md-11'>
                              <Form.Control type="text"  value={OrderSearchTxt}     onChange=
                            {
                              (e) => {
                            setOrderSearchTxt(e.target.value);
                            OrderSearchFun(e.target.value);
                              }
                              }  placeholder="Search" />
</div>

                      </div>
                      
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Select</th>   
           <th>Order No</th>
             <th>Order Date</th>
             <th>Customer Name</th>
             <th>Mobile No</th>   
            
         
           </tr>
         </thead>
         <tbody>
         {dtOrder.map((item) => (
           <tr >
             
             <td>

                                  

    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>OrderSelect(item.OrderId)} >
                   <span className="btn-inner">

                   <svg class="icon-32" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
              <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                
              </svg>  

                     
                   </span>
                 </Link>
   </td>
             <td>{item.OrderId}</td>
             <td>{item.OrderDate}</td>
             <td>{item.CustomerName}</td>
             <td>{item.Mobile}</td>
             
           


             

           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>

     </div>


				
                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>


                <Modal show={CustEntryshow1}  className=".modal-xl" id="EntryModal3" >
                  <Modal.Header >
                    <Modal.Title>Customer Detail</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                       <div className='col-md-4'>

                        <div className='col-md-12'>
                              <Form.Label>Customer Name</Form.Label>
                              <Form.Control type="text"   value={xCustName} onChange=
                            {
                              (e) => {
                            setxCustName(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                            <div className='col-md-12'>
                              <Form.Label>Mobile No</Form.Label>
                              <Form.Control type="text"  value={xMobile} onChange=
                            {
                              (e) => {
                            setxMobile(e.target.value);
                              }}   placeholder="" />
                        
                            </div>

                              <div className='col-md-12'>
                              <Form.Label>Address</Form.Label>
                              <Form.Control type="text"  value={xAddress1} onChange=
                            {
                              (e) => {
                            setxAddress1(e.target.value);
                              }}   placeholder="" />
                              </div>
                              <div className='col-md-12'>
                              <Form.Label></Form.Label>
                         <Form.Control type="text"  value={xAddress2} onChange=
                            {
                              (e) => {
                            setxAddress2(e.target.value);
                              }}   placeholder="" />
                                         </div>
                              <div className='col-md-12'>
                              <Form.Label></Form.Label>
                               <Form.Control type="text"  value={xAddress3} onChange=
                            {
                              (e) => {
                            setxAddress3(e.target.value);
                              }}   placeholder="" />

                            </div>
                            
                            </div>

                            <div className='col-md-4'>
                            <div className='col-md-12'>
                              <Form.Label>Area</Form.Label>
                              <Form.Control type="text"  value={xArea} onChange=
                            {
                              (e) => {
                            setxArea(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>City</Form.Label>
                              <Form.Control type="text"  value={xCity} onChange=
                            {
                              (e) => {
                            setxCity(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Pincode</Form.Label>
                              <Form.Control type="text"  value={xPinCode} onChange=
                            {
                              (e) => {
                            setxPinCode(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Phone</Form.Label>
                              <Form.Control type="text"  value={xPhoneNo} onChange=
                            {
                              (e) => {
                            setxPhoneNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Email Id</Form.Label>
                              <Form.Control type="text"  value={xEmailId} onChange=
                            {
                              (e) => {
                            setxEmailId(e.target.value);
                              }}   placeholder="" />
                        
                            </div>

                              </div>


                              <div className='col-md-4'>
                            <div className='col-md-12'>
                              <Form.Label>Adhar No</Form.Label>
                              <Form.Control type="text"  value={xAdharNo} onChange=
                            {
                              (e) => {
                            setxAdharNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Pan No</Form.Label>
                              <Form.Control type="text"  value={xPanNo} onChange=
                            {
                              (e) => {
                            setxPanNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Mobile No</Form.Label>
                              <Form.Control type="text"  value={xRefMobileNo} onChange=
                            {
                              (e) => {
                            setxRefMobileNo(e.target.value);
                            getxRefName();
                           
                              }} placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Name</Form.Label>
                              <Form.Control type="text"  value={xRefCustName} Readonly="readonly" className="txtReadOnly" onChange=
                            {
                              (e) => {
                            setxRefCustName(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Relation</Form.Label>
                              <select className="form-select"  value={xRefRelation}
                              onChange=
                              {
                                (e) => {
                              setxRefRelation(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtCustRelation.map(
                              (item)=>(
                              <option value={item.Relation}>{item.Relation}</option>
                              )
                              )
                              }
                             </select>

</div>

                              </div>
</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CustSave}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CustEntryClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
                
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
